import { Component, inject } from '@angular/core';
import { MenuOptionsService } from '@shared/services/menu-option-service';
import { FinanceManagementService } from './service/finance-management.service';
import { PageableParamInput } from '../company-management/requests/pageable-param.search';
import { Option } from '@layouts/external-authenticated-layout/options';
import { LayoutDashboard, CreditCard, Landmark, ChevronRight, Receipt } from 'lucide-angular';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'finance-management',
  imports: [RouterOutlet],
  templateUrl: './finance-management.html',
  styleUrl: './finance-management.scss',
})
export class FinanceManagement {

  options: Option[] = [
    {
      title: 'Dashboard',
      icon: LayoutDashboard,
      route: '/external-services/finance-management/finance-dashboard',
      isEnabled: true,
    },
    {
      title: 'Company Bills',
      icon: CreditCard,
      route: '/external-services/finance-management/company-finance-bills-management',
      isEnabled: true,
      permissions: ['ROLE_BILLING_MY_BILLS_VIEW'],
    },
    {
      title: 'Financial Security Management',
      icon: Landmark,
      isEnabled: true,
      permissions: ['ROLE_VIEW_FINANCIAL_SECURITY'],
      children: [
        {
          title: 'Bank Guarantee',
          route:
            '/external-services/finance-management/finance-security-management/omc-bank-guarantee/integrated-and-manual-bank-guarantee',
          isEnabled: true,
          icon: ChevronRight,
          permissions: ['ROLE_VIEW_FINANCIAL_SECURITY'],
        },
        {
          title: 'Cash Guarantee',
          route:
            '/external-services/finance-management/finance-security-management/omc-bank-guarantee/cash-bank-guarantee',
          isEnabled: true,
          icon: ChevronRight,
          permissions: ['ROLE_VIEW_FINANCIAL_SECURITY'],
        },
        {
          title: 'Proof of Payment',
          route:
            '/external-services/finance-management/finance-security-management/proof-of-payment',
          isEnabled: true,
          icon: ChevronRight,
          permissions: ['ROLE_VIEW_FINANCIAL_SECURITY'],
          soon: true,
        },
      ],
    },
    {
      title: 'Statements of Account',
      icon: Receipt,
      route: '/external-services/finance-management/statements-of-account',
      isEnabled: true,
      soon: true,
    },
  ];

  constructor(private menuOptionsService: MenuOptionsService) { }

  ngOnInit(): void {
    this.menuOptionsService.clearMenuOptions();
    this.menuOptionsService.setOptions(this.options);
  }

  ngOnDestroy() {
    this.menuOptionsService.setOptions([]);
  }
}
